var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useCallback } from 'react';
import { usePhoneView, IconButton } from '@michelin/acid-components';
import { get, upperCase } from 'lodash';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Business, LocalShipping, OpenInNew } from '@material-ui/icons';
import { Box, Divider, Tooltip, } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { CentralProviderContext } from '../../../centralProviderContext/CentralProviderContext';
import { isFleetLocation } from '../../../helpers/customers';
import { useGetSelectedLocationAccountNumber } from '../../../hooks/useGetSelectedLocationAccountNumber';
import HitInfoItem from './HitInfoItem';
import { APPS } from '../../../types/Apps';
import { MechanicalCareIcon } from '../../../images/icons/MechanicalCareIcon';
import { FleetOrderIcon } from '../../../images/icons/FleetOrderIcon';
import { isDark } from '../../../types/Theme';
import { GLOBAL_SEARCH_ITEMS, } from '../../../types/GlobalSearch';
var useStyles = makeStyles(function (theme) {
    var _a, _b, _c, _d;
    return createStyles({
        detail: {
            marginTop: '10px',
            padding: '8px',
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        detailContainer: {
            overflowY: 'auto',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            width: '100%',
            backgroundColor: theme.palette.background.paper,
        },
        detailContainerLight: (_a = {},
            _a[theme.breakpoints.up('sm')] = {
                borderLeft: '1px solid rgba(0,0,0,0.1)',
            },
            _a),
        detailContainerDark: (_b = {},
            _b[theme.breakpoints.up('sm')] = {
                borderLeft: '1px solid rgba(255,255,255,0.1)',
            },
            _b),
        btn: {
            background: theme.palette.secondary.dark,
        },
        btnDark: {
            background: theme.palette.background.default,
            color: 'white',
        },
        headerContainer: (_c = {
                display: 'flex',
                flexDirection: 'column'
            },
            _c[theme.breakpoints.down('xs')] = {
                flexDirection: 'row',
            },
            _c.alignItems = 'center',
            _c.justifyContent = 'center',
            _c),
        title: (_d = {},
            _d[theme.breakpoints.up('sm')] = {
                fontSize: '0.9rem',
            },
            _d[theme.breakpoints.down('xs')] = {
                fontSize: '0.8rem',
            },
            _d),
    });
});
var Title = function (_a) {
    var title = _a.title;
    var classes = useStyles();
    return (React.createElement("strong", { className: classes.title }, title));
};
var DetailHeader = function (_a) {
    var icon = _a.icon, title = _a.title, path = _a.path, app = _a.app, _b = _a.disabled, disabled = _b === void 0 ? false : _b, disabledTooltip = _a.disabledTooltip;
    var t = useTranslation().t;
    var classes = useStyles();
    var centralProfile = useContext(CentralProviderContext).centralProfile;
    var base = centralProfile.applications.find(function (a) { return a.app_key === app; });
    var url = get(base, 'url', '');
    var buttonDisabled = !url || disabled;
    return (React.createElement("div", { style: { width: '100%', marginBottom: '10px' } },
        React.createElement("div", { className: classes.headerContainer },
            icon,
            React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "center" },
                React.createElement(Title, { title: title }),
                React.createElement(Tooltip, { title: buttonDisabled ? disabledTooltip || "".concat(t('You do not have permission to visit this application')) : "".concat(t('Browse details in a new tab')) },
                    React.createElement("span", null,
                        React.createElement(IconButton, { disabled: buttonDisabled, onClick: function () { return window.open("".concat(url).concat(url.endsWith('/') ? '' : '/').concat(path)); } },
                            React.createElement(OpenInNew, { color: buttonDisabled ? 'disabled' : 'primary', style: { fontSize: '1.15rem' } })))))),
        React.createElement(Divider, null)));
};
var Detail = function (_a) {
    var children = _a.children;
    var classes = useStyles();
    return (React.createElement("div", { className: classes.detail }, children));
};
var DetailContainer = function (_a) {
    var children = _a.children;
    var dark = isDark();
    var classes = useStyles();
    return (React.createElement("div", { className: "".concat(!dark ? classes.detailContainerLight : classes.detailContainerDark, " ").concat(classes.detailContainer) }, children));
};
var HitDetail = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    var selectedHit = _a.selectedHit;
    var selectedGrant = useContext(CentralProviderContext).selectedGrant;
    var t = useTranslation().t;
    var phoneView = usePhoneView();
    var selectedAccount = selectedGrant.accounts[0];
    var isFleetLoc = isFleetLocation(selectedAccount);
    var selectedLocationAccountNumber = useGetSelectedLocationAccountNumber();
    var getDealerContactsUrl = function (contact) {
        var stNumber = selectedAccount.ship_to_customer;
        var btNumber = selectedAccount.bill_to_customer;
        if (!stNumber || !btNumber) {
            return null;
        }
        return "".concat(btNumber, "/contacts/").concat(stNumber, "/view/").concat(String(contact.hash_key).replace('2~', ''));
    };
    var getOpticCasePONumber = useCallback(function (authorizations) {
        var poItem = authorizations === null || authorizations === void 0 ? void 0 : authorizations.filter(function (item) { return item.authorizationClass === 'poNumber'; });
        return poItem && poItem.length && poItem[0].number;
    }, []);
    var getMechanicalCreatedBy = useCallback(function (personArray) {
        if (personArray && personArray.length) {
            var person = personArray[0];
            var firstName = person.first_name;
            var lastName = person.last_name;
            if (firstName && lastName) {
                return "".concat(firstName, " ").concat(lastName);
            }
        }
        return '';
    }, []);
    var getOrderAssignedTo = useCallback(function (orderAssigns) {
        if (orderAssigns && orderAssigns.length) {
            var profile = orderAssigns[0].profile;
            var firstName = profile.first_name;
            var lastName = profile.last_name;
            if (firstName && lastName) {
                return "".concat(firstName, " ").concat(lastName);
            }
        }
        return '';
    }, []);
    var getOpticCaseVehicleInformation = useCallback(function (_a) {
        var assets = _a.assets, _b = _a.showVIN, showVIN = _b === void 0 ? true : _b;
        return (assets || []).map(function (a, index) {
            var _a, _b, _c;
            var assetType = '-';
            if (a.assetType) {
                assetType = a.assetType.split('_').join(' ');
                assetType = t("".concat(assetType[0].toUpperCase()).concat(assetType.slice(1).toLowerCase()));
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(HitInfoItem, { label: "".concat(t(showVIN ? 'Vehicle TYPE / VIN' : 'Vehicle TYPE')), value: "".concat(assetType).concat(showVIN ? "/ ".concat(a.vin || '-') : '') }),
                a.attributes && React.createElement(HitInfoItem, { label: "".concat(t('Vehicle description')), value: "".concat((_a = a.attributes) === null || _a === void 0 ? void 0 : _a.year, " ").concat((_b = a.attributes) === null || _b === void 0 ? void 0 : _b.make, " ").concat((_c = a.attributes) === null || _c === void 0 ? void 0 : _c.model) }),
                React.createElement(HitInfoItem, { label: "".concat(t('Vehicle Unit Number')), value: a.unit || '-' })));
        });
    }, []);
    if (!selectedHit)
        return React.createElement(DetailContainer, null);
    if (selectedHit.type === GLOBAL_SEARCH_ITEMS.FLEET_ORDER_ITEM || selectedHit.type === GLOBAL_SEARCH_ITEMS.URBAN_ORDER_ITEM) {
        var data = selectedHit.data;
        var isUrbanOrder = selectedHit.type === GLOBAL_SEARCH_ITEMS.URBAN_ORDER_ITEM;
        var app = isUrbanOrder ? APPS.URBAN_ORDER : APPS.FLEET_ORDER;
        var order = data;
        return (React.createElement(DetailContainer, null,
            React.createElement(Detail, null,
                React.createElement(React.Fragment, null,
                    React.createElement(DetailHeader, { icon: React.createElement(FleetOrderIcon, __assign({ fill: true }, (phoneView && { style: { marginRight: '10px' } }))), title: "".concat(t('Order'), " ").concat(order.id, " - ").concat(t(upperCase(order.status ? order.status.split('_').join(' ') : ''))), app: app, path: "".concat(selectedLocationAccountNumber, "/order/").concat(order.id) }),
                    React.createElement(HitInfoItem, { label: t('DR'), value: order.claim_number }),
                    React.createElement(HitInfoItem, { label: t('Provider'), value: (_b = order.provider) === null || _b === void 0 ? void 0 : _b.customer_name }),
                    React.createElement(HitInfoItem, { label: t('Orderer'), value: (_c = order.orderer) === null || _c === void 0 ? void 0 : _c.customer_name }),
                    React.createElement(HitInfoItem, { label: t('PO'), value: order.po_number }),
                    React.createElement(HitInfoItem, { label: t('Created By'), value: "".concat((_d = order.user) === null || _d === void 0 ? void 0 : _d.first_name, " ").concat((_e = order.user) === null || _e === void 0 ? void 0 : _e.last_name) }),
                    React.createElement(HitInfoItem, { label: t('Assigned to'), value: getOrderAssignedTo(order.order_assigns), marginBottom: isUrbanOrder ? 1 : 3 }),
                    isUrbanOrder
                        && (React.createElement(React.Fragment, null,
                            React.createElement(HitInfoItem, { label: t('Vehicle Unit Number'), value: (_f = order.vehicle) === null || _f === void 0 ? void 0 : _f.fleet_id_no }),
                            React.createElement(HitInfoItem, { label: t('Vehicle description'), value: "".concat(((_g = order.vehicle) === null || _g === void 0 ? void 0 : _g.year) || '', " ").concat(((_h = order.vehicle) === null || _h === void 0 ? void 0 : _h.make_name) || '', " ").concat(((_j = order.vehicle) === null || _j === void 0 ? void 0 : _j.model_name) || '') }),
                            React.createElement(HitInfoItem, { label: t('Vehicle VIN'), value: (_k = order.vehicle) === null || _k === void 0 ? void 0 : _k.vin, marginBottom: 3 })))))));
    }
    if (selectedHit.type === GLOBAL_SEARCH_ITEMS.CONTACT_ITEM) {
        var data = selectedHit.data;
        var contact = data;
        var path = isFleetLoc ? "".concat(selectedLocationAccountNumber, "/all-preferences/contacts/").concat(String(contact.hash_key).replace('2~', '')) : getDealerContactsUrl(contact);
        return (React.createElement(DetailContainer, null,
            React.createElement(Detail, null,
                React.createElement(React.Fragment, null,
                    React.createElement(DetailHeader, { icon: (React.createElement(Business, __assign({ color: "primary" }, (phoneView && { style: { marginRight: '10px' } })))), title: "".concat(contact.first_name, " ").concat(contact.last_name), app: isFleetLoc ? APPS.CORE_PROFILE : APPS.DEALER_PROFILE, path: path || '', disabled: !path, disabledTooltip: path ? null : "".concat(t('Unable to navigate to the details page')) }),
                    React.createElement(HitInfoItem, { label: t('Email'), value: contact.email_address }),
                    React.createElement(HitInfoItem, { label: t('Preferred Language'), value: contact.preferred_language }),
                    React.createElement(HitInfoItem, { label: t('Job Title'), value: isFleetLoc
                            ? contact.job_title
                            : (_l = get(contact, 'contact_types[0].role_areas[0].role_area', '')) === null || _l === void 0 ? void 0 : _l.replace(/_/g, ' '), marginBottom: 3 })))));
    }
    if (selectedHit.type === GLOBAL_SEARCH_ITEMS.MECHANICAL_CARE_ITEM) {
        var data = selectedHit.data;
        var item = data;
        return (React.createElement(DetailContainer, null,
            React.createElement(Detail, null,
                React.createElement(React.Fragment, null,
                    React.createElement(DetailHeader, { icon: React.createElement(MechanicalCareIcon, __assign({}, (phoneView && { style: { marginRight: '10px' } }))), title: "".concat(item.id, " - ").concat(t(upperCase(((_m = item.event) === null || _m === void 0 ? void 0 : _m.eventStatus) ? item.event.eventStatus.split('_').join(' ') : ''))), app: APPS.CENTRAL, path: "".concat(selectedLocationAccountNumber, "/admin/mech-cases/").concat(item.id) }),
                    React.createElement(HitInfoItem, { label: t('PO'), value: getOpticCasePONumber(item.authorizations) }),
                    getOpticCaseVehicleInformation({ assets: item.assets }),
                    React.createElement(HitInfoItem, { label: t('Orderer'), value: (_o = item.orderer) === null || _o === void 0 ? void 0 : _o.name }),
                    React.createElement(HitInfoItem, { label: t('Provider'), value: (_p = item.provider) === null || _p === void 0 ? void 0 : _p.name }),
                    React.createElement(HitInfoItem, { label: t('Created By'), value: getMechanicalCreatedBy((_q = item.orderer) === null || _q === void 0 ? void 0 : _q.person), marginBottom: 3 })))));
    }
    if (selectedHit.type === GLOBAL_SEARCH_ITEMS.ONCALL_ITEM) {
        var data = selectedHit.data;
        var item = data;
        return (React.createElement(DetailContainer, null,
            React.createElement(Detail, null,
                React.createElement(React.Fragment, null,
                    React.createElement(DetailHeader, { icon: React.createElement(LocalShipping, __assign({ color: "primary" }, (phoneView && { style: { marginTop: '-5px', marginRight: '10px' } }))), title: "".concat(item.id, " - ").concat(t(upperCase(((_r = item.event) === null || _r === void 0 ? void 0 : _r.eventStatus) ? item.event.eventStatus.split('_').join(' ') : ''))), app: APPS.CENTRAL, path: "".concat(selectedLocationAccountNumber, "/admin/oncall/").concat(item.id) }),
                    React.createElement(HitInfoItem, { label: t('PO'), value: getOpticCasePONumber(item.authorizations) }),
                    getOpticCaseVehicleInformation({ assets: item.assets, showVIN: false }),
                    React.createElement(HitInfoItem, { label: t('Orderer'), value: (_s = item.orderer) === null || _s === void 0 ? void 0 : _s.name }),
                    React.createElement(HitInfoItem, { label: t('Orderer Ship To'), value: (_t = item.orderer) === null || _t === void 0 ? void 0 : _t.shipTo }),
                    React.createElement(HitInfoItem, { label: t('Provider'), value: (_u = item.provider) === null || _u === void 0 ? void 0 : _u.name }),
                    React.createElement(HitInfoItem, { label: t('Provider Ship To'), value: (_v = item.provider) === null || _v === void 0 ? void 0 : _v.shipTo })))));
    }
    // generic
    return (React.createElement(DetailContainer, null,
        React.createElement(Detail, null,
            React.createElement(React.Fragment, null,
                React.createElement(Title, { title: "".concat(t('generic'), " ").concat(selectedHit === null || selectedHit === void 0 ? void 0 : selectedHit.data.id) }),
                React.createElement("span", null, selectedHit === null || selectedHit === void 0 ? void 0 : selectedHit.type),
                React.createElement("span", null, selectedHit === null || selectedHit === void 0 ? void 0 : selectedHit.data.id)))));
};
export default HitDetail;
//# sourceMappingURL=HitDetail.js.map